// extracted by mini-css-extract-plugin
module.exports = {"content":"ModalSelectionItem_content__3GowR","placeholder":"ModalSelectionItem_placeholder__2ZJch","value":"ModalSelectionItem_value__1EJR_"};